import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Only create the client if variables are present to prevent crashes
export const supabase = supabaseUrl && supabaseAnonKey 
  ? createClient(supabaseUrl, supabaseAnonKey) 
  : null;

// Fallback mock data to keep the UI rendering before DB connection
const mockProjects = [
  {
    id: '1',
    title: 'LingoBridge AI',
    description: 'An AI-powered translation layer for oral-only indigenous languages, helping community elders preserve knowledge.',
    image_url: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['NLP', 'PyTorch', 'Next.js'],
    is_featured: true,
    demoLink: "#"
  },
  {
    id: '2',
    title: 'EquityFlow',
    description: 'Predictive resource allocation tool built for local non-profits to identify underserved zones.',
    image_url: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['Data Science', 'Python', 'React'],
    is_featured: true,
    repoLink: "#"
  }
];

export const db = {
  projects: {
    async getAll() {
      if (!supabase) {
        console.warn("Supabase not connected. Showing mock data.");
        return mockProjects;
      }
      const { data, error } = await supabase
        .from('projects_1774886300515')
        .select('*')
        .order('created_at', { ascending: false });
      if (error) throw error;
      return data;
    },
    async getFeatured() {
      if (!supabase) return mockProjects.filter(p => p.is_featured);
      const { data, error } = await supabase
        .from('projects_1774886300515')
        .select('*')
        .eq('is_featured', true);
      if (error) throw error;
      return data;
    }
  },
  posts: {
    async getAll() {
      if (!supabase) return [];
      const { data, error } = await supabase
        .from('posts_1774886300515')
        .select('*')
        .order('published_at', { ascending: false });
      if (error) throw error;
      return data;
    }
  },
  newsletter: {
    async subscribe(email) {
      if (!supabase) {
        console.warn("Supabase not connected. Mocking successful subscription.");
        return true;
      }
      const { error } = await supabase
        .from('newsletter_subs_1774886300515')
        .insert([{ email }]);
      if (error) throw error;
      return true;
    }
  }
};